<template>
    <div>
      <div id="overlay" @click="closeSaveReminderOverlay()" style="position: fixed; width: 100%; height: 100%; top: 0; left: 0; right: 0; bottom: 0; background-color: rgba(0,0,0,0.5); z-index: 10; cursor: pointer;"></div>
      <div class="absolute flex flex-col bg-white shadow rounded-sm h-auto z-20" style="width: 600px; left: calc((100vw - 600px)/2); top:150px;">
          <div class="flex flex-col justify-center px-4 py-2 border-b border-solid border-grey-lightest">
              <div class="flex flex-row mb-2 justify-between items-center">
                  <div class="align-center text-lg text-left font-semibold py-2"> Unsaved Changes</div>
                  <img @click="closeSaveReminderOverlay()" class="w-6 h-6 cursor-pointer" src="../../../assets/close.png">
              </div>
              <label class="text-grey-darker font-light text-xs">Leaving this page will discard all unsaved changes. Please save/cancel changes before you proceed. </label>
              <div class="flex flex-row mt-3 mb-2 justify-start">
                  <div @click="closeSaveReminderOverlay()" class="flex flex-col bg-blue px-6 py-2 justify-center cursor-pointer font-semibold rounded-sm text-white text-sm hover:shadow-md">Okay</div>
              </div>
          </div>
      </div>
    </div>
</template>
<script>
export default {
  methods: {
    closeSaveReminderOverlay: function () {
      this.$emit('close')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/common/modals/UnsavedChanges.vue